import { omitBy } from 'lodash';
import request from '../../../request/request';

const getUsers = ({ page, size, keyword }) => {
  return request({
    url: `/api/users`,
    params: omitBy(
      {
        page: page - 1,
        size,
        keyword
      },
      value => value === undefined || value.toString().trim() === ''
    )
  });
};

// eslint-disable-next-line import/prefer-default-export
export { getUsers };
